import type { SVGProps } from 'react';

interface ArrowLeftIconProps extends SVGProps<SVGSVGElement> {
    color?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
    svgProps?: SVGProps<SVGSVGElement>;
}

const ArrowLeftIcon = ({ color = 'currentColor', width = 24, height = 24, className, svgProps }: ArrowLeftIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" className={className} {...svgProps}>
            <path d="M9.83214 5.00009L1.86011 12.3078L9.83214 19.6155" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22 12.3071H2" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
        </svg>
    );
};

export default ArrowLeftIcon;
